import React, { Component } from 'react';
import { observer } from 'mobx-react';
import emailLoaded from '../../static/images/email2.png'
import emailLoading from '../../static/images/emilgif.gif'
import './index.css'
import home from '../../store/index'
@observer
class Load extends Component {
    render() {
        return (
            <div className='Load'>
                <div>
                    {home.askSuccess ? <img src={emailLoaded} className='emailLoaded' alt="" />:""} 
                    {home.askLoadShow ? <img src={emailLoading} alt="" />:''}
                    {home.askSuccess ? <p>寄信成功</p> : ""}
                    {home.askLoadShow ? <p>寄信中...</p>:""}
                    
                </div>
            </div >
        )
    }
}
export default Load